import { useQuery } from '@tanstack/react-query';
import { appConfigQueryOptions } from '../api/app-config';

/**
 * Flags experimentais vêm do backend em `GET /api/config`, então ligar uma
 * delas em staging é só mudar o env da API — sem rebuild do frontend.
 * Enquanto a resposta não chega (ou falha), a feature fica desligada.
 */
export function useRecurringAvailabilityEnabled(): boolean {
  const { data } = useQuery(appConfigQueryOptions);
  return data?.recurringAvailability === true;
}
